module.exports = __webpack_public_path__ + "img/origin-schedule-background.c91125ed.png";